import { Button } from '@material-ui/core';
import { useUserVipPeriod } from '../../../../libs/hooks';
import moment from 'moment';
import VipRangeEditModal from '@pages/membership/body/VipRangeEditModal';
import { useState } from 'react';

const VipButton = ({ uid, onUpdateGrade }) => {
  const vipInfo = useUserVipPeriod(uid, onUpdateGrade);
  const { gradePeriod, removeGradePeriod, updateGradePeriod } = vipInfo;
  const [visible, setVisible] = useState(false);

  if (!vipInfo.gradePeriod)
    return (
      <>
        <Button
          onClick={() => setVisible(true)}
          color={'primary'}
          variant={'outlined'}
        >
          {'등록'}
        </Button>
        <VipRangeEditModal
          visible={visible}
          close={() => setVisible(false)}
          gradePeriod={gradePeriod}
          updateGradePeriod={updateGradePeriod}
          removeGradePeriod={removeGradePeriod}
        />
      </>
    );

  const { start, end } = gradePeriod;

  return (
    <>
      <Button color={'primary'} onClick={() => setVisible(true)}>
        {`${moment(start).format('YYYY/MM/DD')}
      ~${moment(end).format('YYYY/MM/DD')}`}
      </Button>
      <VipRangeEditModal
        visible={visible}
        close={() => setVisible(false)}
        gradePeriod={gradePeriod}
        updateGradePeriod={updateGradePeriod}
        removeGradePeriod={removeGradePeriod}
      />
    </>
  );
};

export default VipButton;
